const STATE_ABBREVIATIONS = {
    'Western Australia': 'WA',
    'New South Wales': 'NSW',
    'Victoria': 'VIC',
    'Queensland': 'QLD',
    'South Australia': 'SA',
    'Tasmania': 'TAS',
    'Northern Territory': 'NT',
    'Australian Capital Territory': 'ACT',
    'Australia Capital Territory': 'ACT',
};

export function stateSelectOption(type) {
    return {
        label: type.abbreviation || STATE_ABBREVIATIONS[type.name] || type.name,
        value: type.id,
        name: type.name,
    };
}

// Stored values may be a full name or an abbreviation, including a leading space from address lookup.
export function matchingStateOption(options, stored) {
    const value = (stored || '').trim().toLowerCase();

    if (!value) {
        return null;
    }

    return options.find((option) => {
        return option.label.toLowerCase() === value || (option.name || '').toLowerCase() === value;
    }) || null;
}
